import React, {Component} from 'react'
import {format} from 'date-fns'
import ru from 'date-fns/locale/ru'
import ga from 'react-ga'

import InstantBookingStore from 'stores/InstantBookingStore'
import RouteStore from 'stores/RouteStore'
import CategoryStore from 'stores/CategoryStore'
import CargosStore from 'stores/CargosStore'
import ParametersStore from 'stores/ParametersStore'
import UserStore from 'stores/UserStore'

import ActionCreators from 'actions/ActionCreators'

import {createControlFactory} from 'components/Controls'
import SidebarInfoBlock from 'components/SidebarInfoBlock'
import InfoBlockRoute from 'components/InfoBlockRoute'
import InfoBlockStuff from 'components/InfoBlockStuff'
import InfoBlockParameters from 'components/InfoBlockParameters'
import IconControl from 'components/IconControl'
import InstantBookingHow from 'components/InstantBookingHow'
import InstantBookingWhy from 'components/InstantBookingWhy'
import InstantBookingQa from 'components/InstantBookingQa'
import ButtonControl from 'components/ButtonControl'
import InputControl from 'components/InputControl'

import {capitalize} from 'lodash'
import {toMoneyFormat} from '../../../tools/number'

import './InstantBookingFinalInfo.scss'
import IconSVG from 'svg-inline-react'
import {INSTANT_PRICES_TYPE_NAMES} from '../../constants/Instantprices'

import {submitEmailPromocode, dumpState} from 'api'
import {translate as t} from 'lang'

function getStateFromStores() {
    return {
        price: InstantBookingStore.getPrice(),
        distance: InstantBookingStore.getDistance(),
        partDay: InstantBookingStore.getPartDay(),
        locations: RouteStore.getLocations(),
        dates: RouteStore.getDates(),
        selectedCategory: CategoryStore.getSelected(),
        stuff: CargosStore.getDeliveryCargos(),
        totalWeight: CargosStore.getTotalWeight(),
        totalVolume: CargosStore.getTotalVolume(),
        parameters: ParametersStore.getDeliveryParameters(),
        type: InstantBookingStore.getType(),
        userHasToken: UserStore.hasToken(),
        userHasVVauthorization: UserStore.hasVVauthorization(),
        user: UserStore.getUser(),
        promocodeAmount: InstantBookingStore.getPromocodeAmount(),
        selectedPaymentType: InstantBookingStore.getSelectedPaymentTypeName(),
        showInstantBooking: InstantBookingStore.showInstantBooking(),
    }
}

class InstantBookingFinalInfo extends Component {

    constructor(props) {
        super(props)
        const storeStates = getStateFromStores()

        this.state = {
            ...storeStates,
            promocode: '',
            promocodeError: '',
        }

        this.Control = createControlFactory(ActionCreators.updateUser)
    }

    componentDidMount() {
        InstantBookingStore.addChangeListener(this.onChange)
        UserStore.addChangeListener(this.onChange)
    }

    componentWillUnmount() {
        InstantBookingStore.removeChangeListener(this.onChange)
        UserStore.removeChangeListener(this.onChange)
    }

    onChange = () => {
        this.setState(getStateFromStores())
    }

    onBack = () => {
        ga.event({
            category: 'instant_booking_orders',
            action: 'click_button_return_s4_from_summary_page',
            label: this.state.selectedCategory.name,
            value: 1,
        })

        if (window.ym) {
            window.ym('1315865', 'reachGoal', 'click_button_return_s4_from_summary_page');
        }

        const categoryId = this.state.selectedCategory.name
        const stage = `/category/${categoryId}/instant`

        ActionCreators.setStage(stage, this.props.location.query)
    }

    onNext = () => {
        if ((this.state.userHasToken || this.state.userHasVVauthorization) && this.state.selectedPaymentType !== 'payment_invoice') {
            ActionCreators.showLoadingOverlay()

            ActionCreators
            .submit()
            .then(response => {
                if (window.ym) {
                    window.ym('1315865', 'reachGoal', `instant_booking_${INSTANT_PRICES_TYPE_NAMES[this.state.type]}`);
                    window.ym('1315865', 'reachGoal', 'instant_booking_new_order', {
                        calendar_uid: response.uid,
                        calendar_order_id: response.oid,
                        order_price: parseInt(this.state.price, 10),
                        currency: "RUB",
                    });
                }

                ga.event({
                    category: 'orders',
                    action: `instant_booking_${INSTANT_PRICES_TYPE_NAMES[this.state.type]}`,
                    label: this.state.selectedCategory.name,
                    value: this.state.price,
                })

                // In widget mode
                if (window.parent) {
                    window.parent.location.href = response.redirect_url
                } else {
                    window.location.href = response.redirect_url
                }
            })
        } else {
            ga.event({
                category: 'instant_booking_orders',
                action: 'add_orders_new_s4_from_summary_page',
                label: this.state.selectedCategory.name,
                value: 1,
            })

            if (window.ym) {
                window.ym('1315865', 'reachGoal', 'add_orders_new_s4_from_summary_page');
            }

            const categoryId = this.state.selectedCategory.name
            const stage = `/category/${categoryId}/instant-contacts`

            ActionCreators.setStage(stage, this.props.location.query)
        }
    }

    onChangePromocode = (event, promocode) => {
        this.setState({
            promocode,
            promocodeError: '',
        })
    }

    onSubmitPromocode = () => {
        ActionCreators.showLoadingOverlay()

        submitEmailPromocode(this.state.user.email.value, this.state.promocode)
        .then(result => {
            if (result.success === 0 && result.promocode && typeof result.promocode === 'string') {
                this.setState({
                    promocodeError: t(result.promocode),
                })
            } else if (result.success === 0) {
                this.setState({
                    promocodeError: t('SOMETHING_WENT_WRONG'),
                })
                dumpState()
            } else if (result.success === 1 && result.promocode) {
                this.setState({
                    promocodeError: '',
                })

                ActionCreators.setInstantBookingPromocode(result.promocode, result.amount)
                ActionCreators.calculateInstantBookingPrice()
            }
        })
        .catch(error => {
            this.setState({
                promocodeError: t('SOMETHING_WENT_WRONG'),
            })
            dumpState()
        })
        .finally(() => {
            ActionCreators.hideLoadingOverlay()
        })
    }

    onCancelPromocode = () => {
        if (confirm('Отменить промокод?')) {
            ActionCreators.setInstantBookingPromocode('', 0)
            ActionCreators.calculateInstantBookingPrice()
        }
    }

    renderDates = () => {
        let finalDateParts = []

        if (this.state.dates.from) {
            finalDateParts.push(format(this.state.dates.from, 'dddd, DD MMMM YYYY', {locale: ru}))
        }

        if (this.state.dates.to && this.state.dates.from !== this.state.dates.to) {
            finalDateParts.push(format(this.state.dates.to, 'dddd, DD MMMM YYYY', {locale: ru}))
        }

        return capitalize(finalDateParts.join('–')) + ' ' + `c ${format(this.state.partDay.valueSeq().get(0).dt_start, 'HH:mm', {locale: ru})} до ${format(this.state.partDay.valueSeq().get(0).dt_end, 'HH:mm', {locale: ru})}`
    }

    render() {
        const dayPrice = this.state.partDay.valueSeq().get(0).price

        return (
            <section className="InstantBookingFinalInfo">
                <section className="InstantBookingFinalInfo container">
                    <div className="InstantBookingFinalInfo-mainHeaderBlock">
                        <div>
                            <div className="InstantBookingFinalInfo-mainHeader">Проверьте данные вашего заказа</div>
                            <div className="InstantBookingFinalInfo-subheader">и при необходимости отредактируйте его
                            </div>
                        </div>
                        <div className="InstantBookingFinalInfo-phone">
                            <IconSVG
                                className="InstantBookingFinalInfo-phoneIcon"
                                src={require('!svg-inline!./call-icon.svg')}/>

                            <div className="blockPhone-consult">
                                <span>Бесплатный номер для консультации</span>
                                <a href="tel:+79188900295">+7 (918) 890-02-95</a>
                            </div>
                        </div>
                    </div>
                    <div className="InstantBookingFinalInfo-infoBlocks">
                        <div className="InstantBookingFinalInfo-infoBlock">
                            <SidebarInfoBlock
                                title="Дата и время"
                                isEditable
                                showEditAlert
                                category={this.state.selectedCategory}
                                linkToEdit={`${this.state.selectedCategory.name}/instant`}>
                                {this.renderDates()}
                            </SidebarInfoBlock>

                            <SidebarInfoBlock
                                className="InstantBookingFinalInfo-marginTop"
                                title={this.state.distance ? `Маршрут (${this.state.distance}км)` : 'Маршрут'}
                                isEditable
                                showEditAlert
                                category={this.state.selectedCategory}
                                linkToEdit={`${this.state.selectedCategory.name}/route`}>
                                <InfoBlockRoute
                                    locations={this.state.locations}
                                />
                            </SidebarInfoBlock>
                        </div>

                        <SidebarInfoBlock
                            className="InstantBookingFinalInfo-infoBlock"
                            title="Ваши грузы"
                            isEditable
                            showEditAlert
                            category={this.state.selectedCategory}
                            linkToEdit={`${this.state.selectedCategory.name}`}>
                            <InfoBlockStuff
                                stuff={this.state.stuff}
                                totalWeight={this.state.totalWeight}
                                totalVolume={this.state.totalVolume}
                            />
                        </SidebarInfoBlock>

                        <SidebarInfoBlock
                            className="InstantBookingFinalInfo-infoBlock InstantBookingFinalInfo-infoParams"
                            title="Дополнительные услуги"
                            isEditable={
                                !(
                                    (this.state.selectedCategory.name === 'household' || this.state.selectedCategory.name === 'moving')
                                    && this.state.showInstantBooking
                                )
                            }
                            showEditAlert
                            category={this.state.selectedCategory}
                            linkToEdit={`${this.state.selectedCategory.name}/params`}>
                            <InfoBlockParameters parameters={this.state.parameters}/>
                        </SidebarInfoBlock>

                        <SidebarInfoBlock
                            className="InstantBookingFinalInfo-infoBlock"
                            title="Информация об исполнителе"
                            isEditable={false}
                            category={this.state.selectedCategory}>
                            <div>
                                <div className="InstantBookingFinalInfo-carrierLabel">Модель, гос. номер, машина:</div>
                                <div className="InstantBookingFinalInfo-carrierValue">Доступно после бронирования и
                                    назначения машины
                                </div>
                                <div className="InstantBookingFinalInfo-carrierLabel">ФИО водителя:</div>
                                <div className="InstantBookingFinalInfo-carrierValue">Доступно после бронирования и
                                    назначения машины
                                </div>
                                <div className="InstantBookingFinalInfo-carrierLabel">Контактный номер водителя:</div>
                                <div className="InstantBookingFinalInfo-carrierValue">Доступно после бронирования и
                                    назначения машины
                                </div>
                            </div>
                        </SidebarInfoBlock>
                    </div>
                    <div className="InstantBookingFinalInfo-wrapper">
                        <div className="InstantBookingFinalInfo-content">
                            <div className="InstantBookingFinalInfo-finalBlock">
                                <div className="InstantBookingFinalInfo-docsBlock">
                                    <div className="InstantBookingFinalInfo-docsLink">
                                        <IconSVG
                                            className="InstantBookingFinalInfo-docsIcon"
                                            src={require('!svg-inline!./doc.svg')}
                                        />
                                        <a target="_blank" href="/assets/docs/booking/instant-booking-sample.pdf">
                                            Пример договора на перевозку
                                        </a>
                                    </div>
                                    <div className="InstantBookingFinalInfo-vskBlock">
                                        <img className="InstantBookingFinalInfo-vskIcon"
                                             src={`data:image/png;base64,` + require(`!base64!./cunami.jpg`)}/>
                                        <span className="InstantBookingFinalInfo-insurance">
                                           Страхование грузов включено в стоимость перевозки<span
                                            className="InstantBookingFinalInfo-insuranceSum"></span>
                                        </span>
                                    </div>
                                </div>
                                <div className="InstantBookingFinalInfo-priceBlock">
                                    <div className="InstantBookingFinalInfo-finalPrice">
                                        <div className="InstantBookingFinalInfo-finalPriceDetail">
                                            <div>Перевозка:&nbsp;{toMoneyFormat(dayPrice)}₽</div>
                                            {
                                                Object.keys(this.state.parameters).reduce((result, key) => {
                                                    let price = this.state.parameters[key].get('price')
                                                    let priceCoef = this.state.parameters[key].get('price_coef')

                                                    if (key === 'escort' && this.state.parameters[key].get('value') > 0) {
                                                        price = price * this.state.parameters[key].get('value')
                                                    }

                                                    if (price && this.state.parameters[key].get('value')) {
                                                        result.push(
                                                            <div key={key}>
                                                                {this.state.parameters[key].get('title')}:&nbsp;{toMoneyFormat(price)}₽
                                                            </div>,
                                                        )
                                                    }

                                                    if (!price && priceCoef && this.state.parameters[key].get('value')) {
                                                        result.push(
                                                            <div key={key}>
                                                                {this.state.parameters[key].get('title')}:&nbsp;{toMoneyFormat(Math.ceil((priceCoef * dayPrice) - dayPrice))}₽
                                                            </div>,
                                                        )
                                                    }

                                                    return result
                                                }, [])
                                            }
                                            <div>Помощь водителя:&nbsp;0&nbsp;₽</div>
                                            <div>Страхование груза:&nbsp;0&nbsp;₽</div>
                                            {this.state.promocodeAmount > 0 ?
                                                <div className="InstantBookingFinalInfo-finalPriceGreenLine">
                                                    Промокод:&nbsp;–{toMoneyFormat(this.state.promocodeAmount)}₽&nbsp;
                                                    <ButtonControl
                                                        view="blueLink"
                                                        size="s"
                                                        onClick={this.onCancelPromocode}>отменить</ButtonControl>
                                                </div> : null
                                            }
                                        </div>
                                        <div className="InstantBookingFinalInfo-finalPriceLabel">
                                            Итого к оплате:&nbsp;
                                            <span
                                                className="InstantBookingFinalInfo-finalPriceValue">{toMoneyFormat(this.state.price)}₽</span>
                                        </div>
                                        <div className="InstantBookingFinalInfo-promocode">
                                            <InputControl
                                                className="InstantBookingFinalInfo-promocodeInput"
                                                onChange={this.onChangePromocode}
                                                placeholder={t('PROMOCODE')}
                                                error={this.state.promocodeError}
                                            />
                                            <ButtonControl
                                                className="InstantBookingFinalInfo-submitPromocode"
                                                view="blueLink"
                                                size="s"
                                                onClick={this.onSubmitPromocode}>OK</ButtonControl>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="InstantBookingFinalInfo-buttons">
                                <ButtonControl className="InstantBookingFinalInfo-buttonBack"
                                               view="stone"
                                               size="s"
                                               leftIcon={<IconControl name="leftArrow"/>}
                                               onClick={this.onBack}>
                                    {t('BACK')}
                                </ButtonControl>
                                <ButtonControl
                                    className="InstantBookingFinalInfo-buttonNext"
                                    id="next_step"
                                    view="sand"
                                    size="m"
                                    shadow={false}
                                    rightIcon={<IconControl name="rightArrow"/>}
                                    onClick={this.onNext}>
                                    Да, всё верно
                                </ButtonControl>
                            </div>
                        </div>
                    </div>
                </section>
                <InstantBookingWhy/>
                <InstantBookingHow/>
                <InstantBookingQa/>
            </section>
        )
    }
}

export default InstantBookingFinalInfo



// WEBPACK FOOTER //
// ./client/components/InstantBookingFinalInfo/InstantBookingFinalInfo.js